import {FC, SVGProps} from 'react';

export const ArrowRightIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path d="M5 13H14V8L23 14L14 20V15H5V13Z" fill="currentColor" />
	</svg>
);
